export default __webpack_public_path__ + "static/media/loading.e4749cbd.gif";